// assets
import { IconDashboard } from "@tabler/icons";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ArticleIcon from "@mui/icons-material/Article";
import PersonIcon from "@mui/icons-material/Person";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GavelIcon from "@mui/icons-material/Gavel";
import CancelIcon from "@mui/icons-material/Cancel";
import EventNoteIcon from "@mui/icons-material/EventNote";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
  id: "userDashboard",
  // title: 'Dashboard',
  type: "group",
  children: [
    {
      id: "default",
      title: "Dashboard",
      type: "item",
      url: "/userDashboard",
      icon: DashboardRoundedIcon,
      color: "#2196f3", // Blue
      breadcrumbs: false,
    },

    {
      id: "grivance",
      title: "Raise Grievance",
      type: "item",
      url: "/userDashboard/grivance/myRaisedGrivance",
      icon: ReportProblemIcon,
      color: "#f44336", // Red
      breadcrumbs: false,
    },
    {
      id: "academics",
      title: "Academics",
      type: "collapse",
      icon: MenuBookIcon,
      color: "#ff9800", // Orange
      children: [
        {
          id: "readingReport",
          title: "Reading Report",
          type: "item",
          url: "/userDashboard/readingReport/allReadingUpdates",
          breadcrumbs: false,
        },
        {
          id: "lectures",
          title: "Lectures",
          type: "item",
          url: "/userDashboard/academics/lectures",
          breadcrumbs: false,
        },
        {
          id: "exams",
          title: "Exams",
          type: "item",
          url: "/userDashboard/academics/exams",
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "disciplinaryAction",
      title: "Disciplinary Action",
      type: "item",
      url: "/userDashboard/disciplinaryAction/myDisciplinaryActions",
      icon: GavelIcon,
      color: "#ff9800", // Orange
      breadcrumbs: true,
    },
    {
      id: "cancelAdmission",
      title: "Cancel Admission",
      type: "item",
      url: "/userDashboard/cancelAdmission/allCancelAdmissionRequest",
      icon: CancelIcon,
      color: "#e91e63", // Pink
      breadcrumbs: true,
    },
    {
      id: "leave",
      title: "Manage Leave",
      type: "item",
      url: "/userDashboard/manageLeave/manageLeave",
      icon: EventNoteIcon,
      color: "#9c27b0", // Purple
      breadcrumbs: false,
    },
    {
      id: "studentPerformence",
      title: "Student Performance",
      type: "item",
      url: "/userDashboard/studentPerformence/myPerformence",
      icon: TrendingUpIcon,
      color: "#00bcd4", // Cyan
      breadcrumbs: false,
    },

    // {
    //     id: 'library',
    //     title: 'Library',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'requestBook',
    //             title: 'Request Book',
    //             type: 'item',
    //             url: '/userDashboard/library/requestBook',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'requestStatus',
    //             title: 'Request Status',
    //             type: 'item',
    //             url: '/userDashboard/library/requestStatus',
    //             breadcrumbs: false
    //         }
    //     ]
    // },

    // {
    //     id: 'entranceExam',
    //     title: 'Entrance Exam',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'createExam',
    //             title: 'Create Exam',
    //             type: 'item',
    //             url: '/dashboard/entranceExam/createExam',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'All Entrance Exams',
    //             title: 'All Exams',
    //             type: 'item',
    //             url: '/dashboard/entranceExam/allExams',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'Set Questions',
    //             title: 'EntranceQuestions',
    //             type: 'item',
    //             url: '/dashboard/entranceExam/setQuestions',
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    // {
    //     id: 'regularExam',
    //     title: 'Regular Exam',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'allocateExam',
    //             title: 'Allocate Exam',
    //             type: 'item',
    //             url: '/dashboard/regularExam/allocateExam',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'createExam',
    //             title: 'Create Exam',
    //             type: 'item',
    //             url: '/dashboard/regularExam/createExam',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'All Entrance Exams',
    //             title: 'All Exams',
    //             type: 'item',
    //             url: '/dashboard/regularExam/allExams',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'Set Questions',
    //             title: 'EntranceQuestions',
    //             type: 'item',
    //             url: '/dashboard/regularExam/setQuestions',
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    //  {
    //     id: 'VerifyStudent',
    //     title: 'Verify Student',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'Unverified Students',
    //             title: 'Unverified Students',
    //             type: 'item',
    //             url: '/dashboard/verifyStudent/unverifiedStudents',
    //             breadcrumbs: false
    //         },

    //     ]
    // },
    // {
    //     id: 'Batch',
    //     title: 'Batches',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'Create Batch',
    //             title: 'Create Batch',
    //             type: 'item',
    //             url: '/dashboard/batch/createBatch',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'All Batches',
    //             title: 'All Batches',
    //             type: 'item',
    //             url: '/dashboard/batch/allBatches',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'Generate Merit',
    //             title: 'Generate Merit',
    //             type: 'item',
    //             url: '/dashboard/batch/generateMerit',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'Upload Result',
    //             title: 'Upload Result',
    //             type: 'item',
    //             url: '/dashboard/batch/uploadResult',
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    // {
    //     id: 'Admission',
    //     title: 'Admission',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'Register For Admission',
    //             title: 'Register For Admission',
    //             type: 'item',
    //             url: '/dashboard/admission/registerForAdmission',
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    // {
    //     id: 'Questions Bank',
    //     title: 'Question Bank',
    //     type: 'collapse',
    //     icon: ArticleIcon,
    //     // breadcrumbs: false
    //     children: [
    //         {
    //             id: 'Create New Question',
    //             title: 'Create New Question',
    //             type: 'item',
    //             url: '/dashboard/questionBank/createQuestion',
    //             breadcrumbs: false
    //         },
    //         {
    //             id: 'AllQuestions',
    //             title: 'All Questions',
    //             type: 'item',
    //             url: '/dashboard/questionBank/allQuestions',
    //             breadcrumbs: false
    //         }
    //     ]
    // }
  ],
};

export default dashboard;
